// extracted by mini-css-extract-plugin
module.exports = {"imgNav":"Navbar_imgNav__30IzC","navText":"Navbar_navText__33Wzz","navLogo":"Navbar_navLogo__3aml6","imgLogo":"Navbar_imgLogo__2T2AM"};